import { createFileRoute } from "@tanstack/react-router";

import { ImportJobPage } from "../../../../features/catalog/import-job-page";

export const Route = createFileRoute("/_app/catalog/import/$id")({ component: ImportJobRoute });

function ImportJobRoute() {
  const { id } = Route.useParams();
  return <ImportJobPage id={id} />;
}
